// removed by extract-text-webpack-plugin
module.exports = {"welcome":"src-display-apps-AppSearch-index__welcome--SSNwg","mask":"src-display-apps-AppSearch-index__mask--3lvjF"};


//////////////////
// WEBPACK FOOTER
// ./src/display/apps/AppSearch/index.scss
// module id = 4363
// module chunks = 0